<template>
  <b-container class="py-4">
    <b-row align-h="center">
      <b-col lg="12" class="col-xl-8">
        <h1 class="mb-3">My Account</h1>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="12" class="col-xl-8">
        <b-card>
          <b-form-group for="email" label-cols-lg="2" label="E-mail">
            <b-input type="email" v-model="userEmail" disabled readonly />
          </b-form-group>
          <b-form-group
            for="name"
            label-cols-lg="2"
            label="Name"
            :state="userState"
            invalid-feedback="This field is required"
          >
            <b-input v-model="user.name" required />
          </b-form-group>

          <b-form-group
            for="password"
            label-cols-lg="2"
            label="Password"
            description="Minimum 6 characters"
            :state="passwdState"
            invalid-feedback="Minimum length is 6 characters"
          >
            <b-input type="password" v-model="user.password" :aria-invalid="!passwdState" required />
          </b-form-group>

          <b-form-group
            for="password_confirmation"
            label-cols-lg="2"
            label="Confirm password"
            :state="passwdConfirm"
            invalid-feedback="Password confirmation do not mathc"
          >
            <b-input type="password" v-model="user.password_confirmation" required />
            <b-form-invalid-feedback id="input-live-feedback"></b-form-invalid-feedback>
          </b-form-group>
          <b-form-group class="text-right">
            <b-button variant="success" class="mr-2" @click.prevent="update">
              <i class="fas fa-check"></i>
              Save
            </b-button>
            <b-button variant="outline-secondary" :to="{name:'home'}">Cancel</b-button>
          </b-form-group>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isError: false,
      userState: null,
      passwdState: null,
      passwdConfirm: null
    };
  },
  computed: {
    ...mapGetters({
      userName: "auth/userName",
      userEmail: "auth/userEmail"
    }),
    user() {
      return {
        name: this.userName,
        password: "",
        password_confirmation: ""
      };
    }
  },
  methods: {
    ...mapActions({
      updateUser: "auth/updateUser"
    }),
    update() {
      if (!this.validateForm()) {
        return null;
      }
      this.updateUser(this.user)
        .then(res => {
          this.makeToast("success", "Updated", "Updates are saved.");
          this.user.password = "";
          this.user.password_confirmation = "";
        })
        .catch(err => {
          console.log(err);
          this.makeToast("danger", "Error!", "Error while saving updates.");
        });
    },
    validateForm() {
      this.userState = this.user.name.length > 0;
      this.passwdState =
        this.user.password == "" || this.user.password.length >= 6
          ? true
          : false;
      this.passwdConfirm =
        this.user.password == this.user.password_confirmation;

      this.isError = !(this.passwdState && this.passwdConfirm);
      return !this.isError;
    }
  }
};
</script>

<style>
</style>
